"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowDateEdit_1 = require("../../../../../../shared/components/editors/CardRowDateEdit");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var CardRowCheckBoxSetEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxSetEditor");
var PromoCodeTypeEditor = /** @class */ (function (_super) {
    __extends(PromoCodeTypeEditor, _super);
    function PromoCodeTypeEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.key_pprograms = "pprograms";
        return _this;
    }
    PromoCodeTypeEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_LAC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({
                _currency: data.data
            });
        });
        this.SID_BL = this.props.ListBonusLevelsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                bonus_levels_avail: data.data
            });
        });
        this.SID_LB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({
                _brands: data.data
            });
        });
        this.SID_PR = this.props.listPromoReActivations.Subscribe("*", function (id, data) {
            _this.setState({
                reactivation_types_avail: data.data
            });
        });
        this.SID_DA = this.props.listDepositAges.Subscribe("*", function (id, data) {
            _this.setState({
                deposit_age_types_avail: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    //app_currency_id: _item.app_currency_id,
                    //app_currency_title: _item.app_currency_title,
                    expire_day: _item.expire_day,
                    expire_month: _item.expire_month,
                    expire_year: _item.expire_year,
                    description: _item.description,
                    is_can_expire: _item.is_can_expire,
                    is_disposable_codes: _item.is_disposable_codes,
                    is_locked: _item.is_locked,
                    prefix: _item.prefix,
                    template_type_code: _item.promocode_template_type_code,
                    template_type_title: _item.promocode_template_type_title,
                    is_can_used_multiple_times: _item.is_can_used_multiple_times,
                    cms_image_url: _item.cms_image_url,
                    _brands: [],
                    _currency: [],
                    bonus_levels_avail: [],
                    bonus_level_id: 0,
                    bonus_level_title: "",
                    is_all_country: _item.is_all_country,
                    is_allow_by_day_of_week_only: _item.is_allow_by_day_of_week_only,
                    is_allow_on_monday: _item.is_allow_on_monday,
                    is_allow_on_tuesday: _item.is_allow_on_tuesday,
                    is_allow_on_wednesday: _item.is_allow_on_wednesday,
                    is_allow_on_thursday: _item.is_allow_on_thursday,
                    is_allow_on_friday: _item.is_allow_on_friday,
                    is_allow_on_saturday: _item.is_allow_on_saturday,
                    is_allow_on_sunday: _item.is_allow_on_sunday,
                    promo_reactivation_type_code: _item.promo_reactivation_type_code,
                    promo_reactivation_type_title: _item.promo_reactivation_type_title,
                    reactivation_types_avail: [],
                    is_allow_by_day_number_only: _item.is_allow_by_day_number_only,
                    day_numbers_separated_string: _item.day_numbers_separated_string,
                    is_restrict_by_deposit_age: _item.is_restrict_by_deposit_age,
                    deposit_age_type_code: _item.deposit_age_type_code,
                    deposit_age_type_title: _item.deposit_age_type_title,
                    deposit_age_types_avail: [],
                    is_restrict_by_deposit_total_amount_during_deposit_age: _item.is_restrict_by_deposit_total_amount_during_deposit_age,
                    is_restrict_multi_activation_promocode_tpl_by_one_player: _item.is_restrict_multi_activation_promocode_tpl_by_one_player,
                    is_restrict_to_activate_promo_owned_by_different_partner: _item.is_restrict_to_activate_promo_owned_by_different_partner,
                    tabKey: this.key_main
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование шаблона промокода"]);
                    _this.props.ListBonusLevelsAvail.LoadData(_this.state.brand_id);
                });
            }
        }
        else {
            this.setState({
                title: "",
                brand_id: 0,
                brand_title: "",
                //app_currency_id: 0,
                //app_currency_title: "",
                expire_day: 1,
                expire_month: 1,
                expire_year: 2058,
                is_can_expire: false,
                description: "",
                is_disposable_codes: false,
                is_locked: false,
                prefix: "",
                _brands: [],
                _currency: [],
                template_type_code: 0,
                template_type_title: "",
                bonus_levels_avail: [],
                bonus_level_id: 0,
                bonus_level_title: "",
                cms_image_url: "",
                is_all_country: false,
                is_can_used_multiple_times: false,
                is_allow_by_day_of_week_only: false,
                is_allow_on_monday: false,
                is_allow_on_tuesday: false,
                is_allow_on_wednesday: false,
                is_allow_on_thursday: false,
                is_allow_on_friday: false,
                is_allow_on_saturday: false,
                is_allow_on_sunday: false,
                promo_reactivation_type_code: 0,
                promo_reactivation_type_title: "",
                reactivation_types_avail: [],
                is_allow_by_day_number_only: false,
                day_numbers_separated_string: "1,2,3",
                is_restrict_by_deposit_age: false,
                deposit_age_type_code: 0,
                deposit_age_type_title: "",
                deposit_age_types_avail: [],
                is_restrict_by_deposit_total_amount_during_deposit_age: false,
                is_restrict_multi_activation_promocode_tpl_by_one_player: false,
                is_restrict_to_activate_promo_owned_by_different_partner: false,
                tabKey: this.key_main
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание шаблона промокода"]);
            });
        }
        this.props.listAppCurrency.LoadData();
        this.props.listBrands.LoadData();
        this.props.listAffilatesAvail.LoadData();
        this.props.listPromoReActivations.LoadData();
        this.props.listDepositAges.LoadData();
        this.doReSetRules();
    };
    PromoCodeTypeEditor.prototype.componentWillUnmount = function () {
        this.props.listAppCurrency.UnSubscribe(this.SID_LAC);
        this.props.listBrands.UnSubscribe(this.SID_LB);
        this.props.ListBonusLevelsAvail.UnSubscribe(this.SID_BL);
        this.props.listPromoReActivations.UnSubscribe(this.SID_PR);
        this.props.listDepositAges.UnSubscribe(this.SID_DA);
    };
    PromoCodeTypeEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            prefix_rules: { isError: false },
            brand_rules: { isError: false },
            //app_currency_rules: { isError: false },
            template_type_rules: { isError: false },
            bonus_level_rules: { isError: false },
            promo_reactivation_type_rules: { isError: false },
            day_numbers_separated_string_rules: { isError: false },
            deposit_age_type_rules: { isError: false },
        });
    };
    PromoCodeTypeEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: {
                    isError: true, errorMessage: "Поле [имя] не заполнено!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: {
                    isError: true, errorMessage: "Поле [бренд] не выбрано!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        /*if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: {
                    isError: true, errorMessage: "Поле [валюта] не выбрана!"
                },
                tabKey: this.key_main
            })
            return false;
        }*/
        if ((!this.state.prefix) || (this.state.prefix.length === 0)) {
            this.setState({
                prefix_rules: {
                    isError: true, errorMessage: "Поле [префикс] не заполнено!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        else {
            if (this.state.prefix.length > 6) {
                this.setState({
                    prefix_rules: {
                        isError: true, errorMessage: "Поле [префикс] слишком длинное (макс. 6 символов)!"
                    },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        if ((this.state.template_type_code <= 0) || (this.state.template_type_title.length === 0)) {
            this.setState({
                template_type_rules: {
                    isError: true, errorMessage: "Поле [тип промокода] не выбрана!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if (this.state.is_can_used_multiple_times) {
            if ((!this.state.promo_reactivation_type_title) || (this.state.promo_reactivation_type_title.length === 0)) {
                this.setState({
                    promo_reactivation_type_rules: {
                        isError: true, errorMessage: "Поле [тип ре-активации промо] не выбрано!"
                    },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        if (this.state.is_allow_by_day_number_only) {
            if ((!this.state.day_numbers_separated_string) || (this.state.day_numbers_separated_string.length === 0)) {
                this.setState({
                    day_numbers_separated_string_rules: {
                        isError: true, errorMessage: "Поле [дни для активации] не заполнено!"
                    },
                    tabKey: this.key_additional
                });
                return false;
            }
            var isValid = /^[0-9,]*$/.test(this.state.day_numbers_separated_string);
            if (!isValid) {
                this.setState({
                    day_numbers_separated_string_rules: {
                        isError: true, errorMessage: "Поле [дни для активации] содержит некорректные данные!"
                    },
                    tabKey: this.key_additional
                });
            }
        }
        if (this.state.is_restrict_by_deposit_age) {
            if ((!this.state.deposit_age_type_title) || (this.state.deposit_age_type_title.length === 0)) {
                this.setState({
                    deposit_age_type_rules: {
                        isError: true, errorMessage: "Поле [давность депозита] не выбрано!"
                    },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        return true;
    };
    PromoCodeTypeEditor.prototype.getIsDisposableValue = function () {
        if (this.state.is_can_used_multiple_times) {
            return false;
        }
        return this.state.is_disposable_codes;
    };
    PromoCodeTypeEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                prefix: this.state.prefix,
                expire_day: this.state.expire_day,
                expire_month: this.state.expire_month,
                expire_year: this.state.expire_year,
                title: this.state.title,
                description: this.state.description,
                is_can_expire: this.state.is_can_expire,
                is_disposable_codes: this.getIsDisposableValue(),
                is_locked: this.state.is_locked,
                is_req_bonus_level: this.state.is_req_bonus_level,
                bonus_level_id: this.state.bonus_level_id,
                cms_image_url: this.state.cms_image_url,
                is_all_country: this.state.is_all_country,
                is_can_used_multiple_times: this.state.is_can_used_multiple_times,
                is_allow_by_day_of_week_only: this.state.is_allow_by_day_of_week_only,
                is_allow_on_monday: this.state.is_allow_on_monday,
                is_allow_on_tuesday: this.state.is_allow_on_tuesday,
                is_allow_on_wednesday: this.state.is_allow_on_wednesday,
                is_allow_on_thursday: this.state.is_allow_on_thursday,
                is_allow_on_friday: this.state.is_allow_on_friday,
                is_allow_on_saturday: this.state.is_allow_on_saturday,
                is_allow_on_sunday: this.state.is_allow_on_sunday,
                promo_reactivation_type_code: this.state.promo_reactivation_type_code,
                is_allow_by_day_number_only: this.state.is_allow_by_day_number_only,
                day_numbers_separated_string: this.state.day_numbers_separated_string,
                is_restrict_by_deposit_age: this.state.is_restrict_by_deposit_age,
                deposit_age_type_code: this.state.deposit_age_type_code,
                is_restrict_by_deposit_total_amount_during_deposit_age: this.state.is_restrict_by_deposit_total_amount_during_deposit_age,
                is_restrict_multi_activation_promocode_tpl_by_one_player: this.state.is_restrict_multi_activation_promocode_tpl_by_one_player,
                is_restrict_to_activate_promo_owned_by_different_partner: this.state.is_restrict_to_activate_promo_owned_by_different_partner
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон промокода изменен!");
            });
        }
    };
    PromoCodeTypeEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                expire_day: this.state.expire_day,
                expire_month: this.state.expire_month,
                expire_year: this.state.expire_year,
                is_can_expire: this.state.is_can_expire,
                brand_id: this.state.brand_id,
                description: this.state.description,
                is_disposable_codes: this.getIsDisposableValue(),
                prefix: this.state.prefix,
                is_locked: this.state.is_locked,
                title: this.state.title,
                promocode_template_type_code: this.state.template_type_code,
                is_req_bonus_level: this.state.is_req_bonus_level,
                bonus_level_id: this.state.bonus_level_id,
                cms_image_url: this.state.cms_image_url,
                is_all_country: this.state.is_all_country,
                is_can_used_multiple_times: this.state.is_can_used_multiple_times,
                is_allow_by_day_of_week_only: this.state.is_allow_by_day_of_week_only,
                is_allow_on_monday: this.state.is_allow_on_monday,
                is_allow_on_tuesday: this.state.is_allow_on_tuesday,
                is_allow_on_wednesday: this.state.is_allow_on_wednesday,
                is_allow_on_thursday: this.state.is_allow_on_thursday,
                is_allow_on_friday: this.state.is_allow_on_friday,
                is_allow_on_saturday: this.state.is_allow_on_saturday,
                is_allow_on_sunday: this.state.is_allow_on_sunday,
                promo_reactivation_type_code: this.state.promo_reactivation_type_code,
                is_allow_by_day_number_only: this.state.is_allow_by_day_number_only,
                day_numbers_separated_string: this.state.day_numbers_separated_string,
                is_restrict_by_deposit_age: this.state.is_restrict_by_deposit_age,
                deposit_age_type_code: this.state.deposit_age_type_code,
                is_restrict_by_deposit_total_amount_during_deposit_age: this.state.is_restrict_by_deposit_total_amount_during_deposit_age,
                is_restrict_multi_activation_promocode_tpl_by_one_player: this.state.is_restrict_multi_activation_promocode_tpl_by_one_player,
                is_restrict_to_activate_promo_owned_by_different_partner: this.state.is_restrict_to_activate_promo_owned_by_different_partner
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон промокода добавлен!");
            });
        }
    };
    PromoCodeTypeEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PromoCodeTypeEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить шаблон промокода";
        }
        else {
            return "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430 - [" + this.props.record.title + "]";
        }
    };
    PromoCodeTypeEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Префикс:", placeholder: "Введите префикс" }, value: this.state.prefix, onValueChanged: function (newVal) {
                    _this.setState({
                        prefix: newVal,
                        prefix_rules: { isError: false }
                    });
                }, required: true, rules: this.state.prefix_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип промокода:", placeholder: "Выберите тип промокода" }, value: { key: this.state.template_type_code, value: this.state.template_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        template_type_code: newVal.key,
                        template_type_title: newVal.value,
                        template_type_rules: { isError: false }
                    }, function () {
                        // this.loadBonusValidatorsList();
                    });
                }, items: this.props.availPromoTemplateTypes, disabled: this.props.record != null, required: true, rules: this.state.template_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    }, function () {
                        //  this.loadBonusValidatorsList();
                    });
                }, items: this.state._brands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Тип промокода заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Может активироваться много раз одним игроком", value: this.state.is_can_used_multiple_times, onChecked: function (checked) { _this.setState({ is_can_used_multiple_times: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип повторной активации:", placeholder: "Выберите тип повторной активации промо" }, value: { key: this.state.promo_reactivation_type_code, value: this.state.promo_reactivation_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        promo_reactivation_type_code: newVal.key,
                        promo_reactivation_type_title: newVal.value,
                        promo_reactivation_type_rules: { isError: false }
                    });
                }, items: this.state.reactivation_types_avail, disabled: !this.state.is_can_used_multiple_times, required: true, rules: this.state.promo_reactivation_type_rules, allowZeroKey: true }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать наличие депозита для активации", value: this.state.is_restrict_by_deposit_age, onChecked: function (checked) { _this.setState({ is_restrict_by_deposit_age: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Давность депозита:", placeholder: "Выберите максимальную давность депозита" }, value: { key: this.state.deposit_age_type_code, value: this.state.deposit_age_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        deposit_age_type_code: newVal.key,
                        deposit_age_type_title: newVal.value,
                        deposit_age_type_rules: { isError: false }
                    });
                }, items: this.state.deposit_age_types_avail, disabled: !this.state.is_restrict_by_deposit_age, required: true, rules: this.state.deposit_age_type_rules, allowZeroKey: true }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать установленную минимальную сумму депозитов для активации", value: this.state.is_restrict_by_deposit_total_amount_during_deposit_age, onChecked: function (checked) { _this.setState({ is_restrict_by_deposit_total_amount_during_deposit_age: checked }); }, disabled: !this.state.is_restrict_by_deposit_age }),
            this.getDownButtons()));
    };
    PromoCodeTypeEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ cms_image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    PromoCodeTypeEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Промокоды будут иметь срок действия", value: this.state.is_can_expire, onChecked: function (checked) { _this.setState({ is_can_expire: checked }); } }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Срок окончания действия", placeholder: "Выберите срок окончания действия" }, value: { day: this.state.expire_day, month: this.state.expire_month, year: this.state.expire_year }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        expire_day: day,
                        expire_month: month,
                        expire_year: year
                    });
                }, disabled: !this.state.is_can_expire }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Промокоды будут иметь ограничения по уровню игрока", value: this.state.is_req_bonus_level, onChecked: function (checked) {
                    _this.setState({
                        is_req_bonus_level: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Уровень игрока :", placeholder: "Выберите уровень игрока" }, value: { key: this.state.bonus_level_id, value: this.state.bonus_level_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_level_id: newVal.key,
                        bonus_level_title: newVal.value,
                        bonus_level_rules: { isError: false }
                    });
                }, items: this.state.bonus_levels_avail, disabled: !this.state.is_req_bonus_level, required: this.state.is_req_bonus_level, rules: this.state.bonus_level_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Одноразовые промокоды", value: this.state.is_disposable_codes, onChecked: function (checked) { _this.setState({ is_disposable_codes: checked }); }, disabled: this.state.is_can_used_multiple_times }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Активировать только в определенные дни недели", value: this.state.is_allow_by_day_of_week_only, onChecked: function (checked) { _this.setState({ is_allow_by_day_of_week_only: checked }); } }),
            React.createElement(CardRowCheckBoxSetEditor_1.default, { items: [
                    { key: "monday", title: "Понедельник", checked: this.state.is_allow_on_monday },
                    { key: "tuesday", title: "Вторник", checked: this.state.is_allow_on_tuesday },
                    { key: "wednesday", title: "Среда", checked: this.state.is_allow_on_wednesday },
                    { key: "thursday", title: "Четверг", checked: this.state.is_allow_on_thursday },
                    { key: "friday", title: "Пятница", checked: this.state.is_allow_on_friday },
                    { key: "saturday", title: "Суббота", checked: this.state.is_allow_on_saturday },
                    { key: "sunday", title: "Воскресенье", checked: this.state.is_allow_on_sunday }
                ], onChecked: function (key, checked) {
                    if (key == "monday") {
                        _this.setState({ is_allow_on_monday: checked });
                    }
                    if (key == "tuesday") {
                        _this.setState({ is_allow_on_tuesday: checked });
                    }
                    if (key == "wednesday") {
                        _this.setState({ is_allow_on_wednesday: checked });
                    }
                    if (key == "thursday") {
                        _this.setState({ is_allow_on_thursday: checked });
                    }
                    if (key == "friday") {
                        _this.setState({ is_allow_on_friday: checked });
                    }
                    if (key == "saturday") {
                        _this.setState({ is_allow_on_saturday: checked });
                    }
                    if (key == "sunday") {
                        _this.setState({ is_allow_on_sunday: checked });
                    }
                }, disabled: !this.state.is_allow_by_day_of_week_only }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Активировать только в определенные дни месяца", value: this.state.is_allow_by_day_number_only, onChecked: function (checked) { _this.setState({ is_allow_by_day_number_only: checked }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Дни месяца:", placeholder: "Введите номера дней через запятую" }, value: this.state.day_numbers_separated_string, onValueChanged: function (newVal) {
                    _this.setState({
                        day_numbers_separated_string: newVal,
                        day_numbers_separated_string_rules: { isError: false }
                    });
                }, disabled: !this.state.is_allow_by_day_number_only, required: true, rules: this.state.day_numbers_separated_string_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Запретить множественную активацию промокодов шаблона промокода одним игроком", value: this.state.is_restrict_multi_activation_promocode_tpl_by_one_player, onChecked: function (checked) { _this.setState({ is_restrict_multi_activation_promocode_tpl_by_one_player: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Запретить активацию промокода игроком, принадлежащим другому партнеру", value: this.state.is_restrict_to_activate_promo_owned_by_different_partner, onChecked: function (checked) { _this.setState({ is_restrict_to_activate_promo_owned_by_different_partner: checked }); } }),
            this.getDownButtons()));
    };
    PromoCodeTypeEditor.prototype.getPProgramsContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        cms_image_url: newVal
                    });
                }, value: this.state.cms_image_url, buttonIcon: "search" }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Доступно для всех стран", value: this.state.is_all_country, onChecked: function (checked) {
                    _this.setState({
                        is_all_country: checked
                    });
                } }),
            this.getDownButtons()));
    };
    PromoCodeTypeEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    PromoCodeTypeEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    PromoCodeTypeEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        if (this.state.tabKey === this.key_pprograms) {
            return this.getPProgramsContent();
        }
        throw "invalid tabkey -> " + this.state.tabKey;
    };
    PromoCodeTypeEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 780, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" },
                { key: this.key_pprograms, tab: "П.Программы" },
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return PromoCodeTypeEditor;
}(React.Component));
exports.default = PromoCodeTypeEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/PromoCodeTemplateEditor.tsx
// module id = 1960
// module chunks = 0